import { useCurrenciesContext, useSecuritiesContext, type CareOrder } from '@talos/kyoko';
import { useReducer } from 'react';
import {
  careOrdersToManualFillState,
  manualFillCareOrdersSliceReducer,
  type ManualFillCareOrdersState,
} from './manualFillCareOrdersSlice';

export const useManualFillCareOrdersState = (careOrders: CareOrder[]) => {
  const { currenciesBySymbol } = useCurrenciesContext();
  const { securitiesBySymbol } = useSecuritiesContext();
  const [state, dispatch] = useReducer(manualFillCareOrdersSliceReducer, undefined, (): ManualFillCareOrdersState => {
    return careOrdersToManualFillState(careOrders, { currenciesBySymbol, securitiesBySymbol });
  });

  return { state, dispatch };
};
